import { RemediationResponse, RemediationState } from "./Remediation.types.ts";
import { ref } from "vue";
import { $http } from "@/plugins/api";
import { getApiClientUrl } from "@/config/runtimeConfig";

const initialRemediation: RemediationState = {
  isAuto: undefined,
  isToJunk: undefined,
};

export function useRemediation() {
  const remediation = ref<RemediationState>(initialRemediation);

  const getAutoRemediation = async ({
    organisationID,
  }: {
    organisationID: string;
  }): Promise<void> => {
    const res = await $http.get<RemediationResponse>(
      `${getApiClientUrl()}/v1/pt/settings/${organisationID}/autoremediation`,
    );

    if (res.status === 200) {
      const { status } = res.data;
      remediation.value.isAuto = status.value;
    }
  };

  const updateAutoRemediation = async ({
    organisationID,
    status,
  }: {
    organisationID: string;
    status: boolean;
  }): Promise<void> => {
    const res = await $http.put<RemediationResponse>(
      `${getApiClientUrl()}/v1/pt/settings/${organisationID}/autoremediation`,
      {
        status,
      },
      { _hasCustomErrorHandling: true },
    );

    if (res.status === 200) {
      remediation.value.isAuto = status;
    }
  };

  const getRemediateToJunk = async ({
    organisationID,
  }: {
    organisationID: string;
  }): Promise<void> => {
    const res = await $http.get<RemediationResponse>(
      `${getApiClientUrl()}/v1/pt/settings/${organisationID}/remediate-to-junk`,
    );

    if (res.status === 200) {
      const { status } = res.data;
      remediation.value.isToJunk = status.value;
    }
  };

  const updateRemediateToJunk = async ({
    organisationID,
    status,
  }: {
    organisationID: string;
    status: boolean;
  }): Promise<void> => {
    const res = await $http.put<RemediationResponse>(
      `${getApiClientUrl()}/v1/pt/settings/${organisationID}/remediate-to-junk`,
      {
        status,
      },
      { _hasCustomErrorHandling: true },
    );

    if (res.status === 200) {
      remediation.value.isToJunk = status;
    }
  };

  return {
    remediation,
    getAutoRemediation,
    updateAutoRemediation,
    getRemediateToJunk,
    updateRemediateToJunk,
  };
}
